(ns frontend.ui.page.lp-report-editor.common.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::report-tab
 (fn [db [_ report-tab-path]]
   (or (get-in db report-tab-path)
       :master-report)))

(rf/reg-sub
 ::preview-mode?
 (fn [db _]
   (get db ::preview-mode? false)))

(rf/reg-sub
 ::pdf-preview-url
 (fn [db _]
   (get db ::pdf-preview-url)))
